export default __webpack_public_path__ + "static/media/noti-bell.8099f2ca.svg";